<template>
  <nav v-if="menu.length > 0">
    <div class="xl:hidden" :class="{
      'absolute top-full left-0 flex flex-col h-screen w-screen bg-gradient-to-t from-white to-[#dae2f3]': open,
      'hidden': !open
    }">
      <!-- Mobile Nav -->
      <ul id="mobileNav" role="menubar" aria-hidden="false" class="flex flex-col h-full" ref="mobileNav" @keydown.escape="$emit('close')">
        <li v-for="(item, idx) in menu" role="menuitem" aria-haspopup="true" class="h-full flex flex-col items-start pl-12 pr-4 pt-4 text-brand-brand-graydark">
          <a :href="item.fields.url" class="flex items-center text-sm" @click.prevent="submenuOpen=submenuOpen===idx?null:idx" tabindex="1">{{ item.fields.linkText }}
            <svg v-if="item.fields.pillarNavigation"
                 class="h-5 w-5 transition"
                 :class="{'rotate-90':submenuOpen===idx}"
                 stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
              <g>
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"></path>
              </g>
            </svg>
          </a>
          <ul v-if="submenuOpen === idx" aria-hidden="true" role="menu" class="flex flex-col ml-5">
            <li role="menuitem">
              <a :href="item.fields.url" class="block whitespace-no-wrap text-sm p-5" tabindex="1">{{ item.fields.linkText }}</a>
            </li>
            <li v-for="subItem in item.fields.pillarNavigation" role="menuitem">
              <a :href="subItem.fields.url" class="block whitespace-no-wrap text-sm p-5" tabindex="1">{{ subItem.fields.linkText }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!--Desktop Nav -->
    <ul role="menubar" aria-hidden="false" class="hidden xl:flex">
      <li v-for="item in menu" role="menuitem" aria-haspopup="true">
        <a :href="item.fields.url" class="flex">{{ item.fields.linkText }}
          <svg v-if="item.fields.pillarNavigation"
               stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em"
               xmlns="http://www.w3.org/2000/svg">
            <g>
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z"></path>
            </g>
          </svg>
        </a>
        <ul aria-hidden="true" role="menu">
          <li v-for="subItem in item.fields.pillarNavigation" role="menuitem">
            <a :href="subItem.fields.url" class="whitespace-no-wrap">{{ subItem.fields.linkText }}</a>
          </li>
        </ul>
      </li>
    </ul>
    <!-- End Desktop -->
  </nav>
</template>

<script>

export default {
  name: "MenuNavigation",

  props: {
    menu: Array,
    open: Boolean
  },

  data() {
    return {
      submenuOpen: null
    };
  },

  watch: {
    open: function(val) {
      console.log(val);
      if (!val) {
        this.submenuOpen = null;
      }else {
        this.$nextTick(() => {
          const mobileNav = this.$refs.mobileNav;
          mobileNav.children[0].children[0].focus();
        });
      }
    }
  },

}
</script>

<style scoped lang="postcss">
@keyframes slidedown {
  0% {
    transform: rotateX(-60deg);
  }
}

@screen xl {
  nav {
    margin-left: auto;
    align-self: center;

    > ul {
      z-index: 10;
      padding: 0 1rem;
      border-radius: 1rem;
      box-shadow: 3px 3px 0px 0px rgba(0, 0, 0, 0.1);
      background-image: linear-gradient(to left, white, #f1f4fa, #dae2f3);

      li {
        position: relative;
        display: inline-block;

        a {
          display: flex;
          padding: 1.35rem .6rem;
          align-items: center;
          text-decoration: none;
          color: theme(colors.brand.black.500);
          border-right: 1px solid theme(colors.brand.black.500);

          svg {
            transition: transform .25s ease-out;
          }
        }

        &:last-child a {
          border-right: 0;
        }

        a:focus,
        a:hover,
        a:active {
          svg {
            transform: rotate(90deg);
          }
        }

        a:focus + ul,
        a:hover + ul,
        &:focus-within ul,
        ul:hover {
          z-index: 3;
          top: 100%;
          display: block;
          min-width: 250px;
          border-radius: 0 0 10px 10px;
          transform-origin: top center;
          animation: slidedown 200ms ease-in-out;
          background: #ffffff;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
        }

        ul {
          top: 0;
          left: 0;
          padding: 0;
          min-width: 8em;
          display: none;
          position: absolute;
          box-sizing: border-box;

          li {
            display: block;
            width: 100%;

            a {
              border-right: 0;
              padding: 1.5rem 1rem;

              &:focus,
              &:hover,
              &:active {
                color: #ffffff;
                background-image: linear-gradient(to left, theme(colors.brand.orange.400), theme(colors.brand.orange.500));
              }
            }

            &:first-child a {
              box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.3);
            }

            &:last-child a {
              border-radius: 0 0 10px 10px;
            }
          }
        }
      }
    }
  }
}
</style>